import globals from "imports/globals";
import $ from "cash-dom";
import "@lottiefiles/lottie-player";
import { ScrollTween2 as ScrollTween } from "Utilities";

const layout = (function () {
    /**
     * Initialize Slider instances
     */
    $(document).ready(function () {
        if ($(".layout-scrollable-lottie").length) {
            if (globals.debug) console.log("layout-scrollable-lottie initialized");
            var scrollableLotties = [];
            $(".layout-scrollable-lottie")
                .find("lottie-player")
                .each(function () {
                    var player = $(this)[0];
                    var animation = player._lottie;
                    var container = $(player).closest(".layout-scrollable-lottie")[0];
                    var stretch =
                        globals.screenOrientation == "landscape"
                            ? $(container).attr("data-stretch")
                            : $(container).attr("data-stretch") * 1.5;

                    function setSizes() {
                        var animationRect = animation.wrapper.children[0];
                        var animationRatio = parseInt(animationRect.style.height) / parseInt(animationRect.style.width);
                        var screenRatio = window.innerHeight / window.innerWidth;

                        container.style.height = animation.totalFrames * 10 * stretch + "px";
                        animation.resize();
                        animation.wrapper.style.transform = `scale(${
                            1 + Math.abs((screenRatio - animationRatio) * 2)
                        })`;
                    }

                    scrollableLotties.push(
                        new ScrollTween({
                            element: container,
                            from: "top-top",
                            to: "bottom-bottom",
                            callback: function (_n, _el) {
                                // console.log(_n, animation.totalFrames * _n);
                                animation.goToAndStop(animation.totalFrames * _n, true);
                            },
                        })
                    );

                    player.addEventListener("ready", function () {
                        // console.log("player ready");
                        // container.style.height = animation.totalFrames * 10 + "px";
                    });

                    setTimeout(function () {
                        setSizes();
                    }, 500);

                    $(window).on("resize", function () {
                        setSizes();
                    });
                });
        }
    });
})();

export default layout;
